import DataLibraryUploadDialog from 'src/content/DataLibrary/DataLibraryDialog/UploadFileFolder';
import { useUploadWidget } from 'src/context/UploadWidgetContext';

import UploadFloatingWidget from './UploadFloatingWidget';

/**
 * Rendered once at the App root.
 *
 * When isVisible=true the upload dialog is kept mounted (as a Dialog Root child)
 * regardless of open state, so useUploadCoordinator state survives minimize.
 * When isMinimized=true, Dialog open=false hides the portal UI while the
 * component tree stays alive, and the floating widget is shown instead.
 */
export default function GlobalUploadManager() {
  const {
    isVisible,
    isMinimized,
    parentId,
    isUploadFileAllowed,
    minimizeUpload,
    closeUpload,
    updateProgress
  } = useUploadWidget();

  if (!isVisible) return null;

  return (
    <>
      <DataLibraryUploadDialog
        open={!isMinimized}
        onOpenChange={(open) => {
          if (!open) closeUpload();
        }}
      />
      {isMinimized && <UploadFloatingWidget />}
    </>
  );
}
